<template>
  <div class="container">
    <div class="content">
      <h1 class="title">
        {{ $t('maintenanceModeScreen.title') }}
      </h1>
      <div
        v-html="$t('maintenanceModeScreen.description')"
        class="description"
      />
    </div>
  </div>
</template>

<script>
import {mapMutations} from 'vuex'

export default {
  mounted() {
    this.setHideAppUI(true)
  },
  beforeDestroy() {
    this.setHideAppUI(false)
  },
  methods: {
    ...mapMutations(['setHideAppUI']),
  },
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.content {
  max-width: 620px;
}

.title {
  text-align: center;
  margin: 0 0 24px;
}

.description {
  text-align: center;
}
</style>
